export default __webpack_public_path__ + "static/media/CSharp Basico Avancado CERT.7931b8b4.png";